"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maybePluralize = void 0;
/**
 * Adds 's' depending on value, for example user vs users
 * @param count
 * @param noun
 * @param pluralNoun
 * @example maybePluralize(0, 'User') returns '0 Users'
 */
function maybePluralize(count, noun, pluralNoun) {
    return "".concat(count, " ").concat(count === 1 ? noun : pluralNoun || noun + 's');
}
exports.maybePluralize = maybePluralize;
